import ReactDOM from 'react-dom/client';
import { ConvexReactClient } from 'convex/react';
import { ConvexBetterAuthProvider } from '@convex-dev/better-auth/react';
import { authClient } from './lib/auth-client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { Toaster } from './components/ui/toaster';
import './index.css';

import { convex } from './lib/convex';

import { registerSW } from 'virtual:pwa-register';

// Initialize PWA
const updateSW = registerSW({
  onNeedRefresh() {
    console.log('🔄 New content available, click on reload button to update.');
  },
  onOfflineReady() {
    console.log('📶 App is ready to work offline.');
  },
});

// Client initialized in lib/convex.ts
console.log('🔗 Convex client initialized');

console.log('🔗 Convex client initialized with URL:', import.meta.env.VITE_CONVEX_URL);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConvexBetterAuthProvider client={convex} authClient={authClient}>
    <HelmetProvider>
      <App />
      <Toaster />
    </HelmetProvider>
  </ConvexBetterAuthProvider>
);
